import { gql } from '@apollo/client';

const LOG_APPLICATION_ERROR = gql`
  mutation logApplicationError($data: LogApplicationErrorInput!) {
    logApplicationError(data: $data)
  }
`;

export default LOG_APPLICATION_ERROR;
